import React, { useEffect, useState, useCallback, useMemo } from "react"
import Moment from "react-moment"
import { getFieldData } from "../../../Services/appService"
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "../../store/auth";
import {
    useLoadCandidateAppsQuery,
    useLoadAppRuningTasksQuery,
    useLoadAppDocumentsQuery,
    useLoadAppFormLibraryQuery,
} from "../../store/candidateApiSlice";
import { loadAppDocuments, loadAppFormLibrary, loadAppRuningTasks } from "../../store/candidate";
import ViewForm from "../../../Components/ApplicantProcessing/ViewForm";
import AddEditNotes from "../../../Components/ApplicantProcessing/AddEditNotes";
import CandidateInfo from "../CandidateInfo";
import PageHeader from "../../../Components/Comman/PageHeader";
import OnboardingSteps from "./OnboardingSteps";
import PartnerInfo from "../PartnerInfo";
import EnrollmentSteps from "./EnrollmentSteps";
import TimerPopup from "../../../Components/TimerPopup";
import { setCurrentPageTitle, setCurrentRoute } from "../../store/layoutUI";
import UploadDocPopup from "../../../Components/UploadDocPopup";
import ViewFormModal from "../ViewFormModal";
import useDocDownload from "../../hooks/useDocDownload";
import { allowFormLibraryEdit, getFormLibraryEditStatus } from "../../store/forms";
import { getComponentUserStatus, getToolsCount, UpdateComponentsUserStatus } from "../../store/tools";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { getAlert, getConfirmAlert } from "../../../Services/appAlerts";
import { deleteDocument, deleteInsDocument, getDocumentDeleteStatus, getInsDocumentDeleteStatus, insDocumentDeleted } from "../../store/documents";

const INSURANCE_STYLES = {
    shell: {
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        width: "100%"
    },
    hero: {
        borderRadius: "0px",
        padding: "14px 20px",
        border: "1px solid rgba(219, 234, 254, 0.95)",
        background: "#f8fafc",
        boxShadow: "none"
    },
    heroRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "18px",
        flexWrap: "wrap"
    },
    heroCopy: {
        minWidth: "260px",
        flex: "1 1 480px"
    },
    heroTitleRow: {
        display: "flex",
        alignItems: "center",
        gap: "14px"
    },
    heroIcon: {
        width: "32px",
        height: "32px",
        borderRadius: "0px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#000000",
        fontSize: "18px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        flexShrink: 0
    },
    heroTitle: {
        fontSize: "22px",
        fontWeight: 600,
        lineHeight: 1.2,
        color: "#0f172a",
        margin: "0 0 3px 0",
        letterSpacing: "-0.01em"
    },
    heroText: {
        fontSize: "13px",
        lineHeight: 1.5,
        color: "#475569",
        margin: 0,
        maxWidth: "760px"
    },
    heroAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "0px",
        border: "1px solid #2563eb",
        background: "#2563eb",
        color: "#ffffff",
        padding: "9px 18px",
        fontSize: "13px",
        fontWeight: 600,
        boxShadow: "none",
        cursor: "pointer",
        transition: "all 0.2s ease"
    },
    statGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        gap: "14px",
        marginTop: "20px"
    },
    statCard: {
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
        backgroundColor: "#ffffff",
        border: "1px solid #e5e5e5",
        borderRadius: "0px",
        padding: "16px",
        boxShadow: "none",
        transition: "all 0.2s ease"
    },
    statIcon: {
        width: "32px",
        height: "32px",
        borderRadius: "0px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#000000",
        fontSize: "14px",
        flexShrink: 0
    },
    statContent: {
        minWidth: 0
    },
    statLabel: {
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        marginBottom: "4px"
    },
    statValue: {
        fontSize: "24px",
        fontWeight: 600,
        lineHeight: 1,
        color: "#0f172a"
    },
    panel: {
        backgroundColor: "#ffffff",
        border: "1px solid #e5e5e5",
        borderRadius: "0px",
        boxShadow: "none",
        overflow: "hidden"
    },
    cardHeader: {
        padding: "14px 20px",
        borderBottom: "1px solid #e5e5e5",
        background: "transparent"
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        gap: "12px"
    },
    titleIcon: {
        width: "32px",
        height: "32px",
        borderRadius: "0px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#000000",
        fontSize: "14px",
        border: "1px solid #e5e5e5",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        flexShrink: 0
    },
    panelTitle: {
        fontSize: "16px",
        fontWeight: 600,
        color: "#000000",
        margin: "0 0 2px 0"
    },
    panelText: {
        fontSize: "13px",
        color: "#666666",
        margin: 0
    },
    cardBody: {
        padding: 0
    },
    utilityRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
        padding: "14px 18px"
    },
    refreshButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        background: "transparent",
        border: "none",
        color: "#2563eb",
        padding: "0",
        fontSize: "13px",
        fontWeight: 500,
        cursor: "pointer",
        textDecoration: "none"
    },
    alertButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        background: "transparent",
        border: "none",
        color: "#2563eb",
        padding: "0",
        fontSize: "13px",
        fontWeight: 500,
        cursor: "pointer",
        textDecoration: "none"
    },
    tableWrap: {
        overflowX: "auto",
        backgroundColor: "#ffffff"
    },
    table: {
        marginBottom: 0,
        width: "100%",
        minWidth: "1080px",
        borderCollapse: "separate",
        borderSpacing: 0
    },
    tableHeadCell: {
        borderTop: "none",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        background: "#f8fafc",
        borderBottom: "1px solid #e5e5e5",
        padding: "14px 18px"
    },
    cell: {
        verticalAlign: "top",
        padding: "16px 18px",
        borderBottom: "1px solid rgba(241, 245, 249, 1)",
        background: "#ffffff"
    },
    insurerName: {
        fontSize: "14px",
        fontWeight: 600,
        color: "#0f172a",
        lineHeight: 1.4,
        display: "flex",
        alignItems: "center",
        gap: "8px"
    },
    insurerIcon: {
        width: "28px",
        height: "28px",
        borderRadius: "0px",
        background: "#f1f5f9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#64748b",
        fontSize: "13px",
        flexShrink: 0
    },
    rowTitle: {
        fontSize: "12px",
        fontWeight: 600,
        color: "#475569",
        textTransform: "uppercase",
        letterSpacing: "0.02em",
        marginBottom: "2px"
    },
    rowText: {
        fontSize: "13px",
        color: "#1e293b",
        fontWeight: 600,
        lineHeight: 1.4
    },
    primaryAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: "transparent",
        border: "none",
        color: "#2563eb",
        padding: "0",
        fontSize: "13px",
        fontWeight: 500,
        cursor: "pointer",
        textDecoration: "none"
    },
    secondaryAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: "transparent",
        border: "none",
        color: "#2563eb",
        padding: "0",
        fontSize: "13px",
        fontWeight: 500,
        cursor: "pointer",
        textDecoration: "none"
    },
    formActionButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        background: "transparent",
        border: "none",
        color: "#2563eb",
        padding: "0",
        fontSize: "13px",
        fontWeight: 500,
        cursor: "pointer",
        textDecoration: "none"
    },
    formCard: {
        minWidth: "220px",
        width: "100%",
        maxWidth: "285px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        padding: "10px 12px",
        borderRadius: "0px",
        border: "1px solid rgba(219, 234, 254, 0.95)",
        background: "#ffffff",
        boxShadow: "none",
        transition: "all 0.2s ease"
    },
    formCardLeft: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        background: "transparent",
        border: "none",
        padding: 0,
        cursor: "pointer",
        textAlign: "left",
        flex: 1,
        minWidth: 0
    },
    reqEditBtn: {
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        borderRadius: "0px",
        border: "1px solid rgba(191, 219, 254, 0.9)",
        backgroundColor: "#eff6ff",
        color: "#2563eb",
        padding: "6px 10px",
        fontSize: "11.5px",
        fontWeight: 600,
        cursor: "pointer",
        whiteSpace: "nowrap",
        flexShrink: 0,
        transition: "all 0.2s ease"
    },

    formActionIcon: {
        width: "36px",
        height: "36px",
        borderRadius: "0px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#eff6ff",
        border: "1px solid rgba(191, 219, 254, 0.9)",
        color: "#2563eb",
        fontSize: "14px",
        boxShadow: "none",
        flexShrink: 0
    },
    formActionCopy: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "1px",
        lineHeight: 1.2
    },
    formActionText: {
        fontSize: "13.5px",
        fontWeight: 600,
        color: "#2563eb"
    },
    formActionHint: {
        fontSize: "11px",
        fontWeight: 600,
        color: "#64748b"
    },
    lastEditBadge: {
        width: "fit-content",
        boxSizing: "border-box",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "6px",
        padding: "0",
        borderRadius: "0px",
        background: "transparent",
        border: "none",
        fontSize: "11.5px",
        fontWeight: 600,
        color: "#64748b"
    },
    requestEditButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        background: "transparent",
        border: "none",
        color: "#2563eb",
        padding: "0",
        fontSize: "13px",
        fontWeight: 500,
        cursor: "pointer",
        textDecoration: "none"
    },
    textButton: {
        border: "none",
        background: "transparent",
        color: "#2563eb",
        padding: 0,
        fontSize: "12px",
        fontWeight: 600
    },
    dangerButton: {
        border: "none",
        background: "transparent",
        color: "#dc2626",
        padding: 0,
        fontSize: "12px",
        fontWeight: 600
    },
    docCard: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        padding: "10px 12px",
        borderRadius: "0px",
        background: "transparent",
        border: "1px solid #e2e8f0",
        boxShadow: "none",
        width: "100%",
        maxWidth: "260px",
        transition: "all 0.2s ease"
    },
    docHeaderRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "8px"
    },
    docTitleGroup: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        minWidth: 0,
        flex: 1
    },
    docBadgeIcon: {
        width: "30px",
        height: "30px",
        borderRadius: "0px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        color: "#475569",
        fontSize: "13px",
        boxShadow: "none",
        flexShrink: 0
    },
    docNameBtn: {
        border: "none",
        background: "transparent",
        color: "#2563eb",
        fontSize: "13px",
        fontWeight: 600,
        textAlign: "left",
        padding: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        cursor: "pointer"
    },
    docDeleteBtn: {
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        width: "28px",
        height: "28px",
        borderRadius: "0px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fef2f2",
        color: "#dc2626",
        border: "1px solid rgba(254, 202, 202, 0.9)",
        fontSize: "12px",
        cursor: "pointer",
        flexShrink: 0,
        transition: "all 0.2s ease"
    },
    docNotesBtn: {
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        width: "28px",
        height: "28px",
        borderRadius: "0px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8fafc",
        color: "#475569",
        border: "1px solid #e2e8f0",
        fontSize: "12px",
        cursor: "pointer",
        flexShrink: 0,
        transition: "all 0.2s ease"
    },
    mutedText: {
        fontSize: "12px",
        color: "#64748b",
        lineHeight: 1.55
    },
    statusPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px 10px",
        borderRadius: "0px",
        fontSize: "11px",
        fontWeight: 600,
        border: "1px solid rgba(226, 232, 240, 1)",
        backgroundColor: "#f8fafc",
        color: "#475569"
    },
    completePill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "5px 12px",
        borderRadius: "0px",
        fontSize: "12px",
        fontWeight: 600,
        border: "1px solid #2dce89",
        backgroundColor: "#2dce898c",
        color: "#0f172a"
    },
    pendingPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "5px 12px",
        borderRadius: "0px",
        fontSize: "12px",
        fontWeight: 600,
        border: "1px solid #ffd600",
        backgroundColor: "#ffd600",
        color: "#0f172a"
    },
    missingPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "5px 12px",
        borderRadius: "0px",
        fontSize: "12px",
        fontWeight: 600,
        border: "1px solid rgba(254, 202, 202, 1)",
        backgroundColor: "#fef2f2",
        color: "#b91c1c"
    },
    docListItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        border: "1px solid #f1f5f9",
        borderRadius: "0px",
        padding: "8px 12px",
        backgroundColor: "#f8fafc",
        transition: "all 0.2s ease"
    },
    docName: {
        fontSize: "13px",
        fontWeight: 600,
        color: "#2563eb",
        maxWidth: "180px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    emptyState: {
        padding: "28px 20px",
        textAlign: "center",
        color: "#64748b",
        fontSize: "13px"
    }
};

export default function AchInfo() {

    const route = [
        { name: "Contract Management", url: "" },
        { name: "Enrollment Steps", url: "" },
    ];

    const currentUser = getCurrentUser();
    let usrId = currentUser?.id;
    if (currentUser?.linkUser) usrId = currentUser.linkUser;

    const {
        data: candidateAppsSelector = [],
        isLoading: isAppsLoading,
        isFetching: isAppsFetching,
        refetch: refetchCandidateApps
    } = useLoadCandidateAppsQuery(usrId, { skip: !usrId });

    const formLibraryEditStatusSelector = useSelector(getFormLibraryEditStatus);
    const componentUserStatusSelector = useSelector(getComponentUserStatus);
    const insDocumentDeleteStatusSelector = useSelector(getInsDocumentDeleteStatus);

    const toolsCountSelector = useSelector(getToolsCount);
    const safeToolsCount = Array.isArray(toolsCountSelector) ? toolsCountSelector : [];
    const safeComponentUserStatus = Array.isArray(componentUserStatusSelector) ? componentUserStatusSelector : [];

    const [formType, setFormType] = useState("Insurance Information");
    const [formShowHide, setFormShowHide] = useState(false);
    const [formObj, setFormObj] = useState(null);
    const [noteShowHide, setNoteShowHide] = useState(false);
    const [timerShowHide, setTimerShowHide] = useState(false);
    const [notesType, setNotesType] = useState("formEditReq");
    const [selectedDocType, setSelectedDocType] = useState("");
    const [docUploadShowHide, setDocUploadShowHide] = useState(false);
    const [allowEdit, setAllowEdit] = useState(false);

    const workflow = useMemo(() => {
        if (candidateAppsSelector.length > 0) {
            const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
            if (mainWorkflow.length > 0) {
                return mainWorkflow[0];
            }
        }
        return null;
    }, [candidateAppsSelector]);

    const appTasksSelectorResult = useLoadAppRuningTasksQuery(
        { wfId: workflow?.oldWorkflowId, userId: usrId },
        { skip: !workflow?.oldWorkflowId || !usrId }
    );
    const appTasksSelector = appTasksSelectorResult.data || [];
    const { isLoading: isTasksLoading, isFetching: isTasksFetching, refetch: refetchAppTasks } = appTasksSelectorResult;

    const appFormLibrarySelectorResult = useLoadAppFormLibraryQuery(
        { wfId: workflow?.oldWorkflowId, userId: usrId },
        { skip: !workflow?.oldWorkflowId || !usrId }
    );
    const appFormLibrarySelector = appFormLibrarySelectorResult.data || [];
    const { isLoading: isFormsLoading, isFetching: isFormsFetching, refetch: refetchFormLibrary } = appFormLibrarySelectorResult;

    const appDocumentsSelectorResult = useLoadAppDocumentsQuery(
        { wfId: workflow?.oldWorkflowId, userId: usrId },
        { skip: !workflow?.oldWorkflowId || !usrId }
    );
    const appDocumentsSelector = appDocumentsSelectorResult.data || [];
    const { isLoading: isDocsLoading, isFetching: isDocsFetching, refetch: refetchDocuments } = appDocumentsSelectorResult;

    const isInitialLoading = isAppsLoading || isTasksLoading || isFormsLoading || isDocsLoading || (!workflow?.oldWorkflowId && candidateAppsSelector.length === 0);
    const isDataFetching = isAppsFetching || isTasksFetching || isFormsFetching || isDocsFetching;
    const isDataLoading = isInitialLoading || (isDataFetching && appFormLibrarySelector.length === 0);

    const appTasklist = useMemo(() => {
        if (appTasksSelector.length > 0) {
            return appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0);
        }
        return [];
    }, [appTasksSelector]);

    const wfTask = useMemo(() => {
        return appTasklist.length > 0 ? appTasklist[0] : null;
    }, [appTasklist]);

    const reviewerTask = useMemo(() => {
        if (appTasklist.length > 0) {
            const reviewTasks = appTasklist.filter(x => x.registrationType === "WP");
            if (reviewTasks.length > 0) return reviewTasks[reviewTasks.length - 1];
        }
        return null;
    }, [appTasklist]);

    const appFormLibrary = useMemo(() => {
        const firstForm = appFormLibrarySelector.find(x => x.formType === formType);
        return firstForm ? [firstForm] : [];
    }, [appFormLibrarySelector, formType]);

    const sentDocs = useMemo(() => {
        if (appDocumentsSelector.length > 0) {
            return appDocumentsSelector.filter(
                (x) =>
                    // x.type === "send" &&
                    x.uploadType !== "Invoice" &&
                    x.docType !== "internal" &&
                    x.docType !== "Messaging"
            );
        }
        return [];
    }, [appDocumentsSelector]);

    const [handleDownloadFile, downloadingDocId] = useDocDownload();

    const dispatch = useDispatch();

    const handleUpdateComponent = useCallback((compItems, ciid) => {
        const comp = safeComponentUserStatus.filter(x => x.compId === 21);
        let updCompItems = "";
        if (comp.length > 0) {
            updCompItems = comp[0].compItems;
        }
        const compObj = {
            compName: "Insurance",
            performerId: currentUser.id,
            compItems: compItems,
            ciid: ciid,
            wiid: 0,
            iiid: 0,
            compId: 21
        }
        if (compItems !== "" && compItems !== updCompItems) {
            dispatch(UpdateComponentsUserStatus(compObj));
        }
    }, [safeComponentUserStatus, currentUser.id, dispatch]);

    useEffect(() => {
        dispatch(setCurrentPageTitle("STEP-4 : Insurance Information"));
        dispatch(setCurrentRoute(route))
    }, [dispatch, route])

    useEffect(() => {
        if (appFormLibrary.length > 0) {
            let frmItems = "";
            appFormLibrary.map((x, key) => {
                if (key > 0) frmItems += ",";
                frmItems += x.id;
                return x;
            });

            handleUpdateComponent(frmItems, appFormLibrary[0].ciid);
        }
    }, [appFormLibrary, handleUpdateComponent]);

    const getPopover = (notes) => {
        const popover = (
            <Popover id="popover-basic">
                <Popover.Title as="h4">Notes</Popover.Title>
                <Popover.Content>{notes}</Popover.Content>
            </Popover>
        );
        return (
            <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                <button
                    type="button"
                    style={INSURANCE_STYLES.docNotesBtn}
                    title="View Notes"
                >
                    <i className="fa fa-sticky-note-o" aria-hidden="true"></i>
                </button>
            </OverlayTrigger>
        );
    };

    const getCIOStatus = (item) => {
        const insuranceDocs = sentDocs.filter(
            (x) =>
                (x.docType === `insurance_${item.id}` || x.uploadType === `insurance_${item.id}`) &&
                x.deleteFlag !== true
        );

        if (insuranceDocs.length === 0) {
            return <span style={{ color: "#94a3b8", fontSize: "13px" }}>-</span>;
        }

        return (
            <div style={{ display: "flex", flexDirection: "column", gap: "8px", alignItems: "flex-start" }}>
                {insuranceDocs.map(doc => {
                    const docId = doc.id || doc.docId;
                    const docName = doc.documentName || doc.docName || "Document";
                    const isPdf = docName?.toLowerCase().endsWith(".pdf");
                    const isImg = /\.(jpe?g|png)$/i.test(docName);
                    const isDownloading = downloadingDocId === docId;
                    return (
                        <div key={docId} style={INSURANCE_STYLES.docCard}>
                            <div style={INSURANCE_STYLES.docHeaderRow}>
                                <div style={INSURANCE_STYLES.docTitleGroup}>
                                    <span style={{
                                        ...INSURANCE_STYLES.docBadgeIcon
                                    }}>
                                        <i className={`fa ${isPdf ? "fa-file-pdf-o" : isImg ? "fa-file-image-o" : "fa-file-text-o"}`} aria-hidden="true"></i>
                                    </span>
                                    <button
                                        type="button"
                                        style={INSURANCE_STYLES.docNameBtn}
                                        title={docName}
                                        disabled={isDownloading}
                                        onClick={() => handleDownloadFile(doc)}
                                    >
                                        {isDownloading ? (
                                            <>
                                                <i className="fa fa-spinner fa-spin mr-1" aria-hidden="true"></i>
                                                Downloading...
                                            </>
                                        ) : (
                                            docName
                                        )}
                                    </button>
                                </div>

                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    {doc.notes && getPopover(doc.notes)}
                                    <button
                                        type="button"
                                        style={INSURANCE_STYLES.docDeleteBtn}
                                        title="Delete File"
                                        onClick={() => handleDeleteInsuranceDoc(docId)}
                                    >
                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    const handleDocumentLoad = useCallback(() => {
        if (refetchCandidateApps) refetchCandidateApps();
        if (refetchAppTasks) refetchAppTasks();
        if (refetchFormLibrary) refetchFormLibrary();
        if (refetchDocuments) refetchDocuments();
        let usrId = currentUser?.id;
        if (currentUser?.linkUser)
            usrId = currentUser.linkUser;
        if (workflow?.oldWorkflowId > 0) {
            dispatch(loadAppRuningTasks(workflow.oldWorkflowId, usrId, { subscribe: false, forceRefetch: true }));
            dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId, { subscribe: false, forceRefetch: true }));
            dispatch(loadAppDocuments(workflow.oldWorkflowId, usrId, { subscribe: false, forceRefetch: true }));
        }
    }, [refetchCandidateApps, refetchAppTasks, refetchFormLibrary, refetchDocuments, currentUser, workflow?.oldWorkflowId, dispatch]);

    const handleDeleteInsuranceDoc = async (id) => {
        const result = await getConfirmAlert("Warning", "Are you sure you want to delete this Document?", "warning");
        if (result.isConfirmed) {
            try {
                await dispatch(deleteInsDocument(id));
                handleDocumentLoad();
            } catch (error) {
                console.error("Delete failed:", error);
            }
        }
    };

    useEffect(() => {
        if (insDocumentDeleteStatusSelector) {
            getAlert("", "Deleted Successfully", "success");
            dispatch(insDocumentDeleted(false));
            handleDocumentLoad();
        }
    }, [insDocumentDeleteStatusSelector, dispatch, handleDocumentLoad]);

    const handleUploadDocModalShowHide = (type) => {
        if (!reviewerTask) {
            getAlert("Warning", "No Reviewer Found. Please Complete Your Onboarding/Enrollment Form.", "warning");
            return;
        }

        const compName = getFieldData(wfTask?.stateData, "insurancedetails", "Name_of_the_Insurance_Company");
        const cglExp = getFieldData(wfTask?.stateData, "insurancedetails", "Commercial_General_Liability_Expiration");
        const autoExp = getFieldData(wfTask?.stateData, "insurancedetails", "Automobile_Liability_Expiration");
        const umbrellaExp = getFieldData(wfTask?.stateData, "insurancedetails", "Umbrella_Liab_Expiration");
        const workersExp = getFieldData(wfTask?.stateData, "insurancedetails", "Workers_Compensation_Expiration");
        const cyberExp = getFieldData(wfTask?.stateData, "insurancedetails", "Cyber_Privacy_Security_Liab_Expiration");
        const eoExp = getFieldData(wfTask?.stateData, "insurancedetails", "E_and_O_Liab_Expiration");

        if (!compName || !cglExp || !autoExp || !umbrellaExp || !workersExp || !cyberExp || !eoExp) {
            getAlert("Warning", "Please complete the Insurance Information form before uploading the COI document.", "warning");
            return;
        }

        if (type === "save" || type === "") {
            setDocUploadShowHide(false);
            setSelectedDocType("");
            handleDocumentLoad();
        } else {
            setDocUploadShowHide(true);
            setSelectedDocType(type);
        }
    };

    const handleFormShowHide = (frm) => {
        if (frm === "save") {
            setFormShowHide(false);
            setFormObj("");
            let usrId = currentUser.id;
            if (currentUser.linkUser)
                usrId = currentUser.linkUser;
            if (workflow?.oldWorkflowId > 0 && usrId > 0) {
                // forceRefetch is required: without it RTK Query serves the
                // cached (stale) data and the saved insurance details never
                // show up until a manual refresh.
                dispatch(loadAppRuningTasks(workflow.oldWorkflowId, usrId, { subscribe: false, forceRefetch: true }));
                dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId, { subscribe: false, forceRefetch: true }));
                dispatch(loadAppDocuments(workflow.oldWorkflowId, usrId, { subscribe: false, forceRefetch: true }));
            }
        } else {
            setFormShowHide(!formShowHide);
            setFormObj(frm);
            if (frm?.allowEdit === 1) setAllowEdit(true);
        }
    };

    const handleNotesComments = (type, obj) => {
        if (type === "save") {
            setFormObj(null);
            setNoteShowHide(false);
            let usrId = currentUser.id;
            if (currentUser.linkUser)
                usrId = currentUser.linkUser;
            if (workflow?.oldWorkflowId > 0)
                dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId));
        } else {
            setFormObj(obj);
            setNoteShowHide(!noteShowHide);
        }
    };

    const handleTimerModalShowHide = () => {
        setTimerShowHide(!timerShowHide);
    };

    const handleFormUpdate = () => {
        setAllowEdit(false);
        if (formObj?.id > 0)
            dispatch(allowFormLibraryEdit(formObj.id, 0));
    }

    useEffect(() => {
        if (formLibraryEditStatusSelector) {
            let usrId = currentUser.id;
            if (currentUser.linkUser)
                usrId = currentUser.linkUser;
            if (workflow?.oldWorkflowId > 0)
                dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId));
        }
    }, [formLibraryEditStatusSelector, workflow?.oldWorkflowId, currentUser?.id, currentUser?.linkUser, dispatch])





    const getCount = (id) => {
        const toolObj = safeToolsCount.filter(x => x.key == id);
        if (toolObj.length > 0) return toolObj[0].value;
        return 0;
    }

    const getToolCount = (id) => {
        const compObj = safeComponentUserStatus.filter(x => x.compId === id);
        if (compObj.length > 0) {
            const unreadComps = compObj[0].unreadCompItems.split(',').sort();
            const readComps = compObj[0].compItems.split(',').sort();
            let unReadCount = 0;
            unreadComps.filter(x => x !== "").map(x => {
                const rs = readComps.filter(y => y === x);
                if (rs.length === 0) {
                    unReadCount += 1;
                }
            });
            if (unReadCount === 0) {
                return <span className="badge badge-pill badge-success ml-0 text-dark">
                    {getCount(id)}
                </span>
            }
            else {
                return <span className="badge badge-pill badge-danger ml-0">
                    {unReadCount}
                </span>
            }

        } else {
            return <span className="badge badge-pill badge-danger ml-0">
                {getCount(id)}
            </span>
        }
    }

    const showInsuranceDetails = appFormLibrary.some((item) => item?.lastUpdate);
    const insuranceDocumentCount = sentDocs.filter((doc) => doc.docType?.startsWith("insurance_")).length;
    const completedFormCount = appFormLibrary.filter((item) => item?.lastUpdate).length;

    return <React.Fragment>
        <div className="form-group mt-2">
            <style>{`
                .insurance-info-table tbody tr:hover {
                    background-color: #fbfdff;
                }
                .ins-link-btn,
                .ins-link-btn:hover,
                .ins-link-btn:focus,
                .ins-link-btn.focus,
                .ins-link-btn:active,
                .ins-link-btn:not(:disabled):not(.disabled):active {
                  background: none !important;
                  background-color: transparent !important;
                  border: none !important;
                  box-shadow: none !important;
                  outline: none !important;
                  padding: 0 !important;
                }
                .ins-link-btn:hover {
                  text-decoration: underline !important;
                  color: #1d4ed8 !important;
                }
            `}</style>

            <div style={INSURANCE_STYLES.panel}>
                <div style={INSURANCE_STYLES.cardHeader}>
                    <div style={INSURANCE_STYLES.headerRow}>
                        <div style={INSURANCE_STYLES.titleRow}>
                            <span style={INSURANCE_STYLES.titleIcon}>
                                <i className="fa fa-shield" aria-hidden="true"></i>
                            </span>
                            <div>
                                <h2 style={INSURANCE_STYLES.panelTitle}>Insurance Information</h2>
                                <p style={INSURANCE_STYLES.panelText}>
                                    Please complete insurance information form and upload Certificate of Insurance (COI).
                                </p>
                            </div>
                        </div>
                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                            <button
                                type="button"
                                className="btn btn-sm ins-link-btn"
                                style={INSURANCE_STYLES.refreshButton}
                                onClick={handleDocumentLoad}
                                disabled={isDataFetching}
                                title="Refresh Insurance Information"
                            >
                                <i className={`fa fa-refresh ${isDataFetching ? "fa-spin" : ""}`} aria-hidden="true"></i>{" "}
                                {isDataFetching ? "Fetching..." : "Refresh"}
                            </button>

                            <button
                                type="button"
                                className="btn btn-sm ins-link-btn"
                                style={INSURANCE_STYLES.alertButton}
                                onClick={handleTimerModalShowHide}
                            >
                                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                Expiration Alert {getToolCount(27)}
                            </button>
                        </div>
                    </div>
                </div>

                {isDataFetching && appFormLibrary.length > 0 && (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "8px 18px",
                        background: "#eff6ff",
                        borderTop: "1px solid #bfdbfe",
                        borderBottom: "1px solid #bfdbfe",
                        color: "#1e40af",
                        fontSize: "12px",
                        fontWeight: 600
                    }}>
                        <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                            <i className="fa fa-circle-o-notch fa-spin" style={{ color: "#2563eb", fontSize: "13px" }}></i>
                            <span>Fetching updated insurance information...</span>
                        </div>
                        <span style={{ fontSize: "11px", color: "#3b82f6", fontWeight: 500 }}>Updating</span>
                    </div>
                )}

                <div style={INSURANCE_STYLES.cardBody}>
                    <div className="table-responsive" style={INSURANCE_STYLES.tableWrap}>
                        <table className="table align-items-center table-hover mb-0 insurance-info-table" style={INSURANCE_STYLES.table}>
                            <thead>
                                <tr>
                                    <th scope="col" style={INSURANCE_STYLES.tableHeadCell}>Insurance Information</th>
                                    <th scope="col" style={INSURANCE_STYLES.tableHeadCell}>Insurance Form</th>
                                    <th scope="col" style={INSURANCE_STYLES.tableHeadCell}>COI</th>
                                    {/* <th scope="col" style={{ ...INSURANCE_STYLES.tableHeadCell, textAlign: "center" }}>Action</th> */}
                                </tr>
                            </thead>

                            <tbody style={{ opacity: isDataFetching && appFormLibrary.length > 0 ? 0.7 : 1, transition: "opacity 0.2s ease" }}>
                                {isDataLoading ? (
                                    <tr>
                                        <td colSpan={3} style={{ padding: "48px 20px", textAlign: "center", backgroundColor: "#ffffff" }}>
                                            <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                                                <div style={{ width: "40px", height: "40px", background: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center", color: "#000000", fontSize: "16px" }}>
                                                    <i className="fa fa-circle-o-notch fa-spin"></i>
                                                </div>
                                                <div style={{ fontSize: "14px", fontWeight: 600, color: "#0f172a" }}>
                                                    {isDataFetching ? "Fetching insurance details..." : "Loading insurance details..."}
                                                </div>
                                                <div style={{ fontSize: "12px", fontWeight: 500, color: "#64748b" }}>
                                                    Please wait while we retrieve your insurance records.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ) : appFormLibrary.length === 0 ? (
                                    <tr>
                                        <td colSpan="3" style={INSURANCE_STYLES.emptyState}>
                                            <i className="fa fa-shield" aria-hidden="true" style={{ fontSize: "22px", color: "#2563eb", marginBottom: "10px" }}></i>
                                            <h4 style={{ margin: "0 0 6px", color: "#0f172a", fontSize: "16px", fontWeight: 600 }}>No insurance information found</h4>
                                            <p style={{ margin: 0, color: "#64748b", fontSize: "13px" }}>
                                                Insurance records will appear here once available for your onboarding.
                                            </p>
                                        </td>
                                    </tr>
                                ) : (
                                    appFormLibrary.map((item, index) => {
                                        const insurance =
                                            wfTask && wfTask.stateData
                                                ? {
                                                    company: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "Name_of_the_Insurance_Company"
                                                    ),
                                                    cglPolicy: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "Commercial_General_Liability_Policy_Number"
                                                    ),
                                                    cglExp: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "Commercial_General_Liability_Expiration"
                                                    ),
                                                    autoPolicy: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "Automobile_Liability_Policy_Number"
                                                    ),
                                                    autoExp: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "Automobile_Liability_Expiration"
                                                    ),
                                                    umbrellaPolicy: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "Umbrella_Liab_Policy_Number"
                                                    ),
                                                    umbrellaExp: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "Umbrella_Liab_Expiration"
                                                    ),
                                                    workersPolicy: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "Workers_Compensation_Policy_Number"
                                                    ),
                                                    workersExp: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "Workers_Compensation_Expiration"
                                                    ),
                                                    cyberPolicy: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "Cyber_Privacy_Security_Liab_Policy_Number"
                                                    ),
                                                    cyberExp: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "Cyber_Privacy_Security_Liab_Expiration"
                                                    ),
                                                    eoPolicy: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "E_and_O_Liab_Policy_Number"
                                                    ),
                                                    eoExp: getFieldData(
                                                        wfTask.stateData,
                                                        "insurancedetails",
                                                        "E_and_O_Liab_Expiration"
                                                    ),
                                                }
                                                : {};

                                        const { allowEdit, lastUpdate, editRemarks } = item;
                                        const insuranceRows = [
                                            { label: "Commercial General Liability", policy: insurance.cglPolicy, expiry: insurance.cglExp, icon: "fa-building-o" },
                                            { label: "Automobile Liability", policy: insurance.autoPolicy, expiry: insurance.autoExp, icon: "fa-car" },
                                            { label: "Umbrella Liability", policy: insurance.umbrellaPolicy, expiry: insurance.umbrellaExp, icon: "fa-umbrella" },
                                            { label: "Workers Compensation & Employer's Liability", policy: insurance.workersPolicy, expiry: insurance.workersExp, icon: "fa-users" },
                                            { label: "Cyber & Privacy Security Liability", policy: insurance.cyberPolicy, expiry: insurance.cyberExp, icon: "fa-lock" },
                                            { label: "E&O Liability", policy: insurance.eoPolicy, expiry: insurance.eoExp, icon: "fa-briefcase" },
                                        ];
                                        const missingPolicyCount = insuranceRows.filter((row) => !row.policy || !row.expiry).length;

                                        return (
                                            <tr key={item.id || index}>
                                                {/* COL 1: INSURANCE INFORMATION (UNIFIED) */}
                                                <td className="text-wrap align-top" style={INSURANCE_STYLES.cell}>
                                                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
                                                            <div style={INSURANCE_STYLES.insurerName}>
                                                                {insurance.company || "Insurance Policy"}
                                                            </div>
                                                            <div>
                                                                {!lastUpdate ? (
                                                                    <span style={INSURANCE_STYLES.pendingPill}>

                                                                        Required
                                                                    </span>
                                                                ) : missingPolicyCount > 0 ? (
                                                                    <span style={INSURANCE_STYLES.missingPill}>
                                                                        <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                                                        {missingPolicyCount} Missing
                                                                    </span>
                                                                ) : (
                                                                    <span style={INSURANCE_STYLES.completePill}>

                                                                        Complete
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {showInsuranceDetails && (
                                                            <div style={{
                                                                display: "grid",
                                                                gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr))",
                                                                gap: "10px",
                                                                paddingTop: "10px",
                                                                borderTop: "1px dashed #e2e8f0"
                                                            }}>
                                                                {insuranceRows.map((row, rowIndex) => {
                                                                    const hasData = Boolean(row.policy || row.expiry);
                                                                    return (
                                                                        <div key={rowIndex} style={{
                                                                            background: "transparent",
                                                                            borderTop: "none",
                                                                            borderLeft: "none",
                                                                            borderRight: "none",
                                                                            borderBottom: "1px solid #e5e5e5",
                                                                            borderRadius: "0px",
                                                                            padding: "9px 0px",
                                                                            boxShadow: "none",
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            gap: "6px",
                                                                            transition: "all 0.2s ease"
                                                                        }}>
                                                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                                                <span style={{
                                                                                    fontSize: "11.5px",
                                                                                    fontWeight: 600,
                                                                                    color: "#1e293b",
                                                                                    textTransform: "uppercase",
                                                                                    letterSpacing: "0.02em",
                                                                                    overflow: "hidden",
                                                                                    textOverflow: "ellipsis",
                                                                                    whiteSpace: "nowrap"
                                                                                }} title={row.label}>
                                                                                    {row.label}
                                                                                </span>
                                                                            </div>

                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "space-between",
                                                                                gap: "8px",
                                                                                fontSize: "11.5px",
                                                                                paddingTop: "5px",
                                                                                borderTop: "1px dashed #f1f5f9"
                                                                            }}>
                                                                                <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                                                                                    <i className="fa fa-hashtag" style={{ color: "#94a3b8", fontSize: "10px" }}></i>
                                                                                    <span style={{ color: "#64748b" }}>Policy:</span>
                                                                                    <span style={{
                                                                                        fontFamily: "SFMono-Regular, Menlo, Monaco, Consolas, monospace",
                                                                                        color: row.policy ? "#0f172a" : "#94a3b8",
                                                                                        fontWeight: 600
                                                                                    }}>
                                                                                        {row.policy || "-"}
                                                                                    </span>
                                                                                </span>

                                                                                <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                                                                                    <i className="fa fa-calendar" style={{ color: row.expiry ? "#2563eb" : "#94a3b8", fontSize: "10px" }}></i>
                                                                                    <span style={{ color: "#2563eb" }}>Exp:</span>
                                                                                    <span style={{ color: row.expiry ? "#2563eb" : "#94a3b8", fontWeight: 600 }}>
                                                                                        {row.expiry ? <Moment format="MMM Do, YYYY">{row.expiry}</Moment> : "-"}
                                                                                    </span>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>

                                                {/* COL 2: INSURANCE FORM */}
                                                <td className="align-top text-wrap" style={INSURANCE_STYLES.cell}>
                                                    <div style={{ display: "flex", flexDirection: "column", gap: "8px", alignItems: "flex-start" }}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm text-left ins-link-btn"
                                                            style={{
                                                                ...(allowEdit === 1 ? INSURANCE_STYLES.primaryAction : INSURANCE_STYLES.secondaryAction),
                                                                ...INSURANCE_STYLES.formActionButton
                                                            }}
                                                            onClick={() => handleFormShowHide(item)}
                                                        >

                                                            <span style={INSURANCE_STYLES.formActionCopy}>
                                                                <span style={INSURANCE_STYLES.formActionText}>
                                                                    <i className={`fa ${!lastUpdate ? "fa-exclamation-circle" : allowEdit === 1 ? "fa-pencil-square-o" : "fa-eye"}`} style={{ marginRight: "6px" }} aria-hidden="true"></i>
                                                                    {!lastUpdate ? <>Add Insurance Details <span className="text-danger">*</span></> : allowEdit === 1 ? "Edit Insurance" : "View Insurance"}
                                                                </span>

                                                            </span>
                                                        </button>

                                                        {allowEdit === 0 && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm ins-link-btn"
                                                                style={INSURANCE_STYLES.requestEditButton}
                                                                onClick={() => handleNotesComments("", item)}
                                                                title="Request For Edit"
                                                            >
                                                                <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                                                Request For Edit
                                                            </button>
                                                        )}

                                                        {allowEdit === 2 && (
                                                            <div style={INSURANCE_STYLES.mutedText}>
                                                                <span style={INSURANCE_STYLES.statusPill}>Request Sent</span>
                                                                {editRemarks && (
                                                                    <div className="mt-1">{editRemarks}</div>
                                                                )}
                                                            </div>
                                                        )}

                                                        {lastUpdate && (
                                                            <div style={INSURANCE_STYLES.lastEditBadge}>

                                                                <span>
                                                                    <strong>Edited:</strong>{" "}
                                                                    <Moment format="MMM Do YYYY, h:mm a">
                                                                        {lastUpdate}
                                                                    </Moment>
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>

                                                {/* COL 3: COI (UPLOADED DOCUMENTS ONLY) */}
                                                <td className="align-top" style={INSURANCE_STYLES.cell}>{getCIOStatus(item)}</td>

                                                {/* COL 4: ACTION (UPLOAD BUTTON) */}
                                                {/* <td className="align-top text-center" style={INSURANCE_STYLES.cell}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm ins-link-btn"
                                                        style={INSURANCE_STYLES.primaryAction}
                                                        onClick={() => handleUploadDocModalShowHide(`insurance_${item.id}`)}
                                                    >
                                                        <i className="fa fa-upload" aria-hidden="true"></i> Upload
                                                    </button>
                                                </td> */}
                                            </tr>
                                        );
                                    }))}
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>
        {docUploadShowHide &&
            <UploadDocPopup
                contactDoc="Insurance Document Uploaded Successfully"
                uploadDocShowHide={docUploadShowHide}
                handleUploadDocModalShowHide={handleUploadDocModalShowHide}
                runningApplication={reviewerTask ? [reviewerTask] : []}
                selectedDocType={selectedDocType}
            ></UploadDocPopup>}

        {formShowHide && <ViewFormModal
            viewFormShowHide={formShowHide}
            handleViewForm={handleFormShowHide}
            workflowTask={wfTask}
            selectedForm={formObj}
            handleFormUpdate={handleFormUpdate}
            allowEdit={allowEdit}
            formName="Insurance Information"
        ></ViewFormModal>}

        {noteShowHide && <AddEditNotes
            noteShowHide={noteShowHide}
            handleNoteShowHide={handleNotesComments}
            notesType={notesType}
            candidateObj={currentUser}
            selectedObj={formObj}
        ></AddEditNotes>}
        {timerShowHide &&
            <TimerPopup
                timerShowHide={timerShowHide}
                handleTimerModalShowHide={handleTimerModalShowHide}
                workflowTask={wfTask}
            ></TimerPopup>}
    </React.Fragment>
}



